module.exports = __webpack_public_path__ + "static/media/logo_full.c36f73fd.jpg";